"use client";
import { useEffect as u } from "react";
import { useControllableState as l } from "@radix-ui/react-use-controllable-state";
const i = (s) => {
  const { isOpen: o, onOpenChange: a, shortcutKey: t } = s ?? {}, [p = !1, n] = l({
    prop: o,
    defaultProp: o,
    onChange: a
  });
  return u(() => {
    const r = (e) => {
      t && (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === t.toLowerCase() && (e.preventDefault(), e.stopPropagation(), n(!0)), e.key === "Escape" && o && (e.preventDefault(), n(!1));
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [t, n, o]), {
    isOpen: p,
    setOpen: n,
    shortcutKey: t
  };
};
export {
  i as useInkeepModal
};
